import { render, staticRenderFns } from "./ModalCreateActivity.vue?vue&type=template&id=bfc3f486"
import script from "./ModalCreateActivity.vue?vue&type=script&lang=js"
export * from "./ModalCreateActivity.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateActivity.vue?vue&type=style&index=0&id=bfc3f486&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports